<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Pending Approval</h1>
      </div>
    </div>

    <div class="container-fluid">

      <div class="dashboard-results-details">
        <div class="w-full flex flex-wrap justify-between spacer-b-2">
          <div class="count"><span>{{ pagination.total }}</span> Pending {{ $t('Requests') }}</div>
          <booking-list-sort
            :set-filter-mutation="setFilter"
            :filters="filters"
          />
        </div>
      </div>

      <booking-list-filters
        :set-filter-mutation="setFilter"
        :filters="filters"
        :apply-filters="handleApplyFiltersCallback">
        <ladda-button
          slot="button"
          :click="handleApplyFiltersCallback"
          type="submit"
          class="btn btn-primary pull-right">
          Search
        </ladda-button>
      </booking-list-filters>

      <div class="dashboard-block">
        <ul class="nav nav-tabs" role="tablist">
          <li :class="{ 'active': status === 'vetting' }">
            <router-link :to="{ params: { status: 'vetting' }, query: $route.query }">Vetting</router-link>
          </li>
          <li :class="{ 'active': status === 'draft' }">
            <router-link :to="{ params: { status: 'draft' }, query: $route.query }">Drafts</router-link>
          </li>
          <li :class="{ 'active': status === 'archived' }">
            <router-link :to="{ params: { status: 'archived' }, query: $route.query }">Archived Drafts</router-link>
          </li>
        </ul>
        <pickstar-loading v-if="fetchingVettingBookingRequests" class="m-t-lg"/>

        <template v-else>
          <no-results v-if="haveNoVettingBookingRequests">
            <div>There are no pending requests.</div>

            <button v-if="haveAppliedFilters" @click="handleResetFiltersCallback" class="btn btn-default btn-sm m-t-sm">Reset Filters</button>
          </no-results>

          <ul v-else class="list-items">
            <vetting-list-item
              v-for="booking in requests"
              :key="booking.id"
              :booking="booking"/>
          </ul>

          <lazy-loading
            class="text-center"
            :loading="loading"
            :reached-bottom="handleGetNextVettingBookingRequestsCallback"
            ref="lazyLoading">
            <pickstar-loading slot="loading"/>
            <span slot="finished"></span>
          </lazy-loading>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { appliesFilters, handleServerErrors } from 'mixins'
import VettingListItem from './VettingListItem'
import BookingListFilters from 'components/booking/BookingListFilters'
import BookingListSort from 'components/booking/BookingListSort'
import LazyLoading from 'codium-lazy-loading'

export default {
  mixins: [appliesFilters, handleServerErrors],

  components: {
    VettingListItem,
    BookingListFilters,
    BookingListSort,
    LazyLoading
  },

  data () {
    return {
      fetchingVettingBookingRequests: false
    }
  },

  computed: {
    ...mapState('booking/request/vetting', ['requests', 'pagination', 'filters']),
    ...mapGetters('booking/request/vetting', ['initialFiltersState']),
    ...mapState('app', ['loading']),

    haveNoVettingBookingRequests () {
      return this.requests.length === 0
    },

    status () {
      if (this.$route.params.status) {
        return this.$route.params.status
      }
      return 'vetting'
    }
  },

  watch: {
    '$route' () {
      this.handleGetVettingBookingRequestsCallback()
    }
  },

  methods: {
    ...mapActions('booking/request/vetting', ['getVettingBookingRequests', 'getNextVettingBookingRequests', 'setFilter', 'resetFilters']),

    /**
     * Handle getting the vetting booking requests.
     *
     * @return Promise
     */
    handleGetVettingBookingRequestsCallback () {
      this.fetchingVettingBookingRequests = true

      return this.getVettingBookingRequests(this.queryParams)
        .catch(this.handleServerErrorsCallback)
        .finally(() => {
          this.fetchingVettingBookingRequests = false

          this.$nextTick(() => {
            if (!this.$refs.lazyLoading) {
              return
            }

            this.$refs.lazyLoading.$emit('reset')
          })
        })
    },

    /**
     * Handle get the next vetting booking requests.
     *
     * @return Promise
     */
    handleGetNextVettingBookingRequestsCallback () {
      return this.getNextVettingBookingRequests(this.queryParams)
        .catch(this.handleServerErrorsCallback)
    }
  }
}
</script>
